import styles from './adminNps.module.scss';
import {Table, Spin} from 'antd';
import {useNavigate, useParams} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import pageNotFound from 'images/pageNotFound.png';
import moment from 'moment';
import {GET_ALL_USER_NET_PROMOTER_SCORES} from 'graphql/queries/nps';
import gamer from 'images/gamer.png';
import backIcon from 'images/back.png';
import UserLink from 'components/userLink/UserLink';

const UserScore = () => {
  const navigate = useNavigate();
  const {id} = useParams();

  const {data, loading} = useQuery(GET_ALL_USER_NET_PROMOTER_SCORES, {
    variables: {
      userId: id,
    },
  });

  const columns = [
    {
      title: 'Full Name',
      dataIndex: 'firstName',
      key: 'firstName',
      render: (text, record) => (
        <div className={styles['record-label']}>
          <div className={styles['record-name']}>
            {record?.user?.imageUrl ? (
              <img src={record?.user?.imageUrl} alt="" />
            ) : (
              <img src={gamer} alt="" />
            )}
            <h4>
              <UserLink userId={record?.user?.id}>
                {record?.user?.firstName} {record?.user?.lastName}
              </UserLink>
            </h4>
          </div>
        </div>
      ),
    },
    {
      title: 'Score',
      dataIndex: 'recommendationScore',
      key: 'recommendationScore',
      render: (text, record) => (
        <div>
          <span>{record?.recommendationScore}</span>
        </div>
      ),
    },
    {
      title: 'Feedback',
      dataIndex: 'feedback',
      key: 'feedback',
      render: (text, record) => (
        <div>
          <span>{record?.feedback}</span>
        </div>
      ),
    },
    {
      title: 'Creation Date',
      dataIndex: 'createdAt',
      key: 'creationdate',
      render: (text, record) => (
        <span>{moment(record?.createdAt).format('DD MMMM YYYY')}</span>
      ),
    },
  ];

  if (loading) {
    return (
      <div className={styles.loading}>
        <Spin size="large" />
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <div className={styles['container-wrapper']}>
      <div className={styles.header}>
        <img
          onClick={() => navigate('/dashboard/customers/nps')}
          src={backIcon}
          alt=""
        />
        <h1>User Net Promoter Scores</h1>
      </div>
      <div className={styles['startup-table']}>
        <div className={styles['table-height']}>
          {data?.getNetPromoterScoreByUserId?.userNetPromoterScore?.length >=
          1 ? (
            <div>
              <Table
                columns={columns}
                dataSource={
                  data?.getNetPromoterScoreByUserId?.userNetPromoterScore
                }
              />
            </div>
          ) : (
            <div className={styles['no-update']}>
              <img src={pageNotFound} alt="" />
              <h1>No User Net Promoter Score found</h1>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserScore;
